import {
  reqAuthLogin,
  reqUserTokenAccessEnabled,
  reqGetCurrentUserInfo,
  reqLogout,
  reqGetUser,
} from "@/api/api.js";
import {
  setToken,
  setMenu,
  setName,
  getToken,
  removeToken,
  removeMenu,
  removeName,
} from "@/utils/setToken";
import Router from "vue-router";
import routesTenant from "@/router/routesTenant";
import routesAdmin from "@/router/routesAdmin";
import routesCustomer from "@/router/routesCustomer";
import router from "@/router";

const state = {
  token: getToken("token"),
  token1:"",
  curUserInfo: {},
  menuList: "",
  customerId: "",
  customerInfo: [],
};
const mutations = {
  AUTHLOGIN(state, data) {
    state.token = data.token;
    if (data.pwd === "sysadmin") {
      state.menuList = "menu-sysadmin";
    } else if (data.pwd === "tenant") {  //原：else if (data.pwd === "tenant")
      state.menuList = "menu-tenant";
    } else {
      state.menuList = "menu-customer";
    }
  },
  AUTHLOGIN1(state, data) {
    state.token1 = data.token;
  },
  GETUSERTOKENACCESSENABLED() {},
  GETCURRENTUSERINFO(state, curUserInfo) {
    state.curUserInfo = curUserInfo;
  },
  CLEAR(state) {
    state.token = "";
    state.curUserInfo = {};
    removeToken("token");
    removeMenu("menu");
    removeName("name");
  },
  GETUSER(state, id) {
    state.customerId = id;
  },
};
const actions = {
  async authLogin({ commit }, data) {
    let result = await reqAuthLogin(data);
    let data1 = {
      username: "tenant@thingsboard.org",
      password: "houlei1327",
      // password: "tenant",
    };
    let result1 = await reqAuthLogin(data1);
    if (result.status === 200) {
      const pwd = data.password;
      result.data.pwd = pwd;
      commit("AUTHLOGIN", result.data);
      commit("AUTHLOGIN1", result1.data);
      // if (pwd === "tenant") {
      if (pwd === "houlei1327") {
        routesTenant.forEach((route) => {
          router.options.routes.push(route);
        });
      } else if (pwd === "sysadmin") {
        routesAdmin.forEach((route) => {
          const isRouteExists = router.options.routes.some((existingRoute) => {
            return existingRoute.path === route.path;
          });
          if (!isRouteExists) {
            router.options.routes.push(route);
          }
        });
      } else {
        routesCustomer.forEach((route) => {
          const isRouteExists = router.options.routes.some((existingRoute) => {
            return existingRoute.path === route.path;
          });
          if (!isRouteExists) {
            router.options.routes.push(route);
          }
        });
      }
      router.matcher = new Router({ routes: router.options.routes }).matcher;
      setToken("token", result.data.token);
      setMenu("menu", data.password);
      setName("name", data.username);
      return "ok";
    } else {
      removeToken("token");
      removeMenu("menu");
      removeName("name");
      return "fail";
    }
  },
  async getUserTokenAccessEnabled({ commit }) {
    let result = await reqUserTokenAccessEnabled();
    if (!result) {
      removeToken("token");
      removeMenu("menu");
      removeName("name");
    } else if (result.status === 200) {
      commit("GETUSERTOKENACCESSENABLED", result);
      return "ok";
    } else {
      removeToken("token");
      removeMenu("menu");
      removeName("name");
    }
  },
  async getCurrentUserInfo({ commit }) {
    let result = await reqGetCurrentUserInfo();
    if (!result) {
      removeToken("token");
      removeMenu("menu");
      removeName("name");
    } else if (result.status === 200) {
      commit("GETCURRENTUSERINFO", result.data);
      setToken("token", state.token);
      return "ok";
    } else {
      removeToken("token");
      removeMenu("menu");
      removeName("name");
    }
  },
  async userLogout({ commit }) {
    let result = await reqLogout();
    if (result.status === 200) {
      removeToken("token");
      removeMenu("menu");
      removeName("name");
      router.options.routes = [];
      commit("CLEAR");
      return "ok";
    } else {
      removeToken("token");
      removeMenu("menu");
      removeName("name");
    }
  },
  async getUser({ commit }) {
    let result = await reqGetUser();
    if (result.status === 200) {
      commit("GETUSER", result.data.data[0].customerId.id);
    }
  },
};
const getters = {};

export default {
  state,
  mutations,
  actions,
  getters,
};
